export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/combination-provider-arrow-top.e2d3d128-0dbdee.svg";